import template   from './catalog-navbar.html'
import controller from './catalog-navbar.controller'
import './catalog-navbar.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/catalog-navbar/catalog-navbar.component.js